import { d as decode } from './built-get-url-variant-a647ef33.js';

const defaults = {
  url: false,
  callback: false,
  target: false,
  duration: 120,
  on: 'mouseover',
  touch: true,
  onZoomIn: false,
  onZoomOut: false,
  magnify: 1
};

jQuery.zoom = (t, i, n, o) => {
  let a;
  let r;
  let s;
  let c;
  let l;
  let d;
  let u;
  const p = jQuery(t);
  const f = p.css('position');
  const h = jQuery(i);
  t.style.position = /(absolute|fixed)/.test(f) ? f : 'relative';
  t.style.overflow = 'hidden';
  n.style.width = '';
  n.style.height = '';
  jQuery(n).addClass('zoomImg').css({
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    width: n.width * o,
    height: n.height * o,
    border: 'none',
    maxWidth: 'none',
    maxHeight: 'none'
  }).appendTo(t);
  return {
    init() {
      r = p.outerWidth();
      a = p.outerHeight();

      if (i === t) {
        c = r;
        s = a;
      } else {
        c = h.outerWidth();
        s = h.outerHeight();
      }

      l = (n.width - r) / c;
      d = (n.height - a) / s;
      u = h.offset();
    },

    move(e) {
      let t = e.pageX - u.left;
      let i = e.pageY - u.top;
      i = Math.max(Math.min(i, s), 0);
      t = Math.max(Math.min(t, c), 0);
      n.style.left = t * -l + "px";
      n.style.top = i * -d + "px";
    }

  };
};

jQuery.fn.zoom = function (opts) {
  return this.each(function () {
    const n = jQuery.extend({}, defaults, opts || {});
    const o = n.target && jQuery(n.target)[0] || this;
    const a = this;
    const r = jQuery(a);
    const s = document.createElement('img');
    const c = jQuery(s);
    const l = 'mousemove.zoom';

    if (!n.url) {
      const p = a.querySelector('img');
      if (p) n.url = p.getAttribute('data-src') || p.currentSrc || p.src;
      if (!n.url) return;
    }

    r.one('zoom.destroy', ((e, t) => {
      r.off('.zoom');
      o.style.position = e;
      o.style.overflow = t;
      s.addEventListener('load', null);
      c.remove();
    }).bind(this, o.style.position, o.style.overflow));
    s.addEventListener('load', () => {
      function t(t) {
        p.init();
        p.move(t);
        c.stop().fadeTo(jQuery.support.opacity ? n.duration : 0, 1, Boolean(jQuery.isFunction(n.onZoomIn)) && n.onZoomIn.call(s));
      }

      function i() {
        c.stop().fadeTo(n.duration, 0, Boolean(jQuery.isFunction(n.onZoomOut)) && n.onZoomOut.call(s));
      }

      const p = jQuery.zoom(o, a, s, n.magnify);
      if (n.on === 'grab') r.on('mousedown.zoom', n => {
        if (n.which === 1) {
          jQuery(document).one('mouseup.zoom', () => {
            i();
            jQuery(document).off(l, p.move);
          });
          t(n);
          jQuery(document).on(l, p.move);
          n.preventDefault();
        }
      });else if (n.on === 'click') r.on('click.zoom', () => {// Return d ? void 0 : (d = true, t(n), e(document).on(l, p.move), e(document).one("click.zoom", function() {
        //     i(), d = false, e(document).off(l, p.move)
        // }), false)
      });else if (n.on === 'toggle') r.on('click.zoom', () => {// D ? i() : t(e), d = !d
      });else if (n.on === 'mouseover') {
        p.init();
        r.on('mouseenter.zoom', t).on('mouseleave.zoom', i).on(l, p.move);
      }
      if (n.touch) r.on('touchstart.zoom', () => {// E.preventDefault(), u ? (u = false, i()) : (u = true, t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
      }).on('touchmove.zoom', () => {// E.preventDefault(), p.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
      }).on('touchend.zoom', () => {// E.preventDefault(), u && (u = false, i())
      });
      if (jQuery.isFunction(n.callback)) n.callback.call(s);
    });
    s.src = n.url;
  });
};

jQuery.fn.zoom.defaults = defaults;

// @ts-check

/**
 * @typedef Group
 * @property {string} color
 * @property {string[]} images
 */
class ImageGroups {
  constructor(groupOn, productJSON) {
    this.groupOn_ = groupOn || 'Color';
    this.optionKey_ = null;
    /** @type {Group[]} */

    this.groups_ = [];
    this.currentImage_ = '';
    this.productJSON = productJSON || window.productJSON;
    this.findOptionNumber_();
    this.initGroups_();
    this.buildGroups_();
  }

  findOptionNumber_() {
    for (let i = 0; i < this.productJSON.options.length; i++) if (this.productJSON.options[i] === this.groupOn_) this.optionKey_ = "option" + (i + 1);
  }

  initGroups_() {
    for (let i = 0; i < this.productJSON.variants.length; i++) {
      const t = this.productJSON.variants[i];

      if (this.currentImage_ !== t.featured_image.src) {
        this.currentImage_ = t.featured_image.src;
        this.groups_.push({
          color: t[this.optionKey_],
          images: [this.currentImage_]
        });
      }
    }
  }

  buildGroups_() {
    let t = 0;

    for (let i = 0; i < this.productJSON.images.length; i++) {
      const n = this.productJSON.images[i];

      for (let j = 0; j < this.groups_.length; j++) if (n === this.groups_[j].images[0].replace(/^https:/, '')) t = j;

      if (n !== this.groups_[t].images[0].replace(/^https:/, '')) this.groups_[t].images.push(n);
    }
  }

  getGroups() {
    return this.groups_;
  }

}

const uuid = window.uuid;

const slugify = e => e.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

function optionToSwatch() {
  const wrapperEl = jQuery('.selector-wrapper');
  wrapperEl.find('label').each((i, labelEl) => {
    const text = jQuery(labelEl).text();
    jQuery(labelEl).data('title', text);
    jQuery(labelEl).text(text);
    jQuery(labelEl).parent().addClass(['selector-wrapper', slugify(text)].join('--'));
  });
  wrapperEl.each(function () {
    const options = []; // I don't think that `.single-option-selector` ever exists. Can the related logic be removed?

    const n = jQuery(this).find('.single-option-selector');
    const labelName = jQuery(this).find('label').data('title') || uuid().replace(/-/g, '');
    n.find('option').each((i, optionEl) => {
      options.push("<a href=\"#\" class=\"option option--" + slugify(labelName) + "-" + slugify(jQuery(optionEl).val()) + "\" data-value=\"" + jQuery(optionEl).val().replace('"', '&quot;') + "\">" + jQuery(optionEl).text() + "</a>");
    });
    n.hide();
    jQuery(this).append("<div class=\"options\" data-option=\"" + n.data('option') + "\">" + options.join('') + "</div>");

    if (labelName !== 'Size') {
      jQuery(this).not('.selector-wrapper--size').find('.options .option').not('.disabled').first().addClass('option--active');
    }

    jQuery(this).find('.options .option').on('click', function (e) {
      e.preventDefault();
      jQuery(this).parent().find('.option').removeClass('option--active');
      jQuery(this).addClass('option--active');
      jQuery(this).parents('.selector-wrapper').find('label').addClass('is-selected').text(jQuery(e.currentTarget).data('value'));
      n.val(jQuery(e.currentTarget).data('value')).change();
    });

    if (jQuery(this).find('.options .option').length === 1) {
      jQuery(this).find('.options .option').first().click();
    }
  }); // Why does this return a promise?

  return Promise.resolve();
}

jQuery(document).ready(() => {
  const decathlon = window.decathlon;
  const s = '//reviews.decathlon.com';
  const l = 1e3;
  Handlebars.registerHelper('ratings', e => {
    const t = [];
    const value = Math.floor(e);

    for (let i = 0; i < 5; ++i) if (i < value) t.push('<i class="ico ico--star u-textYellow"></i>');else t.push('<i class="ico ico--star"></i>');

    return new Handlebars.SafeString(t.join(''));
  });
  Handlebars.registerHelper('inflection', (count, word) => count === 1 ? word : word + "s");
  Handlebars.registerHelper('date', e => {
    const dateWithoutTZ = e.split('T')[0];
    const t = new Date(dateWithoutTZ);
    return String(t.getMonth() + 1) + "/" + t.getDate() + "/" + t.getFullYear().toString().substr(2);
  });
  let G = true;
  const breakpoint = 768;

  function handlebarsSafeCompile(string) {
    if (string) {
      return Handlebars.compile(string);
    }

    return data => {
      /**
       * @TODO - remove logs for production
       * This should be used to see what's trying to compile against elements
       * that have been removed from the baseline template
       */
      console.debug('Data being passed to nonexistent string for Handlebars', data);
      return '';
    };
  }

  function v(e) {
    const currentSlide = jQuery(e.currentTarget).find('.slick-current');
    currentSlide.addClass('is-loadingZoom');
    currentSlide.zoom({
      url: currentSlide.find('img').data('original'),

      callback() {
        currentSlide.removeClass('is-loadingZoom');
      }

    });
  }

  function updateProductSlides() {
    const currentIndex = jQuery('.js-slick--products .slick-current').data('slick-index');
    const numSlides = jQuery('.js-slick--products .slick-slide:not(.slick-cloned)');
    const productImages = jQuery('.productImages');

    if (jQuery(window).width() <= breakpoint) {
      productImages.css('margin-left', 0);
    } else {
      if (numSlides.length < 4 && currentIndex === 0) productImages.css('margin-left', window.innerWidth / 3);else if (numSlides.length === 3 && currentIndex === 2) productImages.css('margin-left', -window.innerWidth / 3);else productImages.css('margin-left', 0);

      if (G) {
        G = false;
        setTimeout(() => {
          jQuery('.productImages').removeClass('is-instant');
        }, 310);
      }
    }
  }

  function y() {
    let i = jQuery(window).height() - jQuery('.js-de-PageWrap-header').height() - jQuery('.productOptions').height() - 182;

    if (i > 500) {
      const n = 0.5 * (i - 500);
      jQuery('.productImages').css({
        padding: n + "px 0"
      });
      i = 500;
    } else jQuery('.productImages').css({
      padding: 0
    });

    jQuery('.productImage').height(i);
  }

  const productWrap = jQuery('#ProductWrap');
  const modelCode = productWrap.data('modelCode');
  if (!productWrap.hasClass('product-singleOption')) optionToSwatch().then(() => {
    jQuery('.selector-wrapper--color .custom-variants').slick({
      slidesToShow: 5,
      arrows: true,
      infinite: false,
      responsive: [{
        breakpoint: 1120,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 1e3,
        settings: {
          slidesToShow: 5
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 5
        }
      }]
    });
  });

  if (decathlon.cookieData_.recentlyViewed && decathlon.cookieData_.recentlyViewed.length > 0) {
    const W = handlebarsSafeCompile(jQuery('#recentlyViewedTemplate').html());
    jQuery('.js-recentlyViewed').html(W({
      products: decathlon.cookieData_.recentlyViewed
    }));
  } else jQuery('.recentlyViewed').remove();

  decathlon.recentlyViewed({
    url: "/products/" + window.productJSON.handle,
    title: window.productJSON.title,
    price: "$" + window.productJSON.price / 100,
    featured_image: window.productJSON.featured_image,
    id: window.productJSON.id,
    rating: window.productJSON.rating
  });
  jQuery('.js-slick--products').on('beforeChange', e => {
    jQuery(e.currentTarget).find('.slick-current').trigger('zoom.destroy');
  }).on('afterChange', v).on('init', v);
  jQuery('.js-slick--products').slick({
    centerPadding: 0,
    dots: true,
    focusOnSelect: true,
    infinite: true,
    slidesToShow: 3,
    centerMode: true,
    lazyLoad: 'ondemand',
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        infinite: false,
        dots: false
      }
    }]
  });
  jQuery('.js-slick--products').on('afterChange', updateProductSlides);
  jQuery('.selector-wrapper--color .option').on('click', updateProductSlides);
  jQuery('.js-slick--products .productImage').click(updateProductSlides);
  jQuery(window).resize(updateProductSlides);
  if (jQuery(window).width() <= breakpoint) jQuery('.productImage.slick-slide img').removeAttr('data-action');

  if (jQuery(window).width() >= l) {
    y();
    jQuery(window).resize(y);
    decathlon.pinToHeader({
      selector: '.js-pinProductOptions',

      offset() {
        return 0;
      },

      pinCallback() {
        jQuery(document.body).addClass('is-pinningForm');
      },

      unpinCallback() {
        jQuery(document.body).removeClass('is-pinningForm');
      }

    });
  }

  const imageGroups = new ImageGroups().getGroups();
  jQuery(imageGroups).each((index, i) => {
    jQuery(i.images).each((e, n) => {
      let o = n.replace(/^https:/, '').split('.jpg');
      o = o.join('_large.jpg');
      jQuery(".productImage img[data-lazy=\"" + o + "\"]").parent().attr('data-color', i.color);
    });
  });
  jQuery('.js-slick--products').on('reInit', function () {
    jQuery(this).removeClass('is-filtering');
  });
  jQuery('.js-slick--products').slick('slickFilter', function () {
    if (jQuery(this).data('color') === imageGroups[0].color) return true;
  });
  jQuery('.js-slick--products .slick-slide:not(.slick-cloned)').each((e, i) => {
    jQuery(i).attr('data-slick-index', e);
  });
  jQuery('.productFAQs h4').each((e, i) => {
    jQuery(i).addClass('productFAQs-faq-title');
    jQuery(i).nextUntil('h4').addBack().wrapAll('<div class="productFAQs-faq" />');
    jQuery(i).append('<a class="productFAQs-faq-toggleLink js-toggleFAQ" href="#"></a>');
  });
  jQuery('.js-toggleFAQ').on('click', function (e) {
    e.preventDefault();
    jQuery(this).parents('.productFAQs-faq').toggleClass('is-open');
  });

  const initWithModelCode = () => {
    const V = jQuery('.js-loadProductVideo');
    if (V) jQuery.ajax({
      url: V.data('poster'),
      type: 'HEAD'
    }).success(() => {
      V.append("<div class=\"banner banner--video banner--billboard banner--centeredContent banner--productVideo\" style=\"background-image: url(" + V.data('poster') + ")\" ><div class=\"wrapper\"><div class=\"banner-content\"><h1 class=\"banner-title\">See it in action</h1><a class=\"js-bannerVideo\" href=\"//players.brightcove.net/3415345270001/rJxNjfhX_default/index.html?videoId=ref:" + V.data('videoId') + "_1&secureConnections=true&secureHTMLConnections=true&autoplay=true\" target=\"_blank\"><i class=\"ico ico--play h2 u-marginBottom0x\"></i></a></div></div></div>");
      jQuery('.js-bannerVideo').on('click', function (i) {
        i.preventDefault();
        const n = jQuery(this).parents('.banner--video');
        const o = jQuery(this).attr('href');
        n.append("<div id=\"bannerVideo\"><div class=\"js-closeBannerVideo\"></div><div class=\"embedWrapper\"><div class=\"embedContainer\"><iframe src=\"" + o + "\" frameborder=\"0\" allowfullscreen></iframe></div></div></div>");

        if (jQuery(this).attr('data-videoButton')) {
          const a = JSON.parse(jQuery(this).attr('data-videoButton'));
          jQuery('#bannerVideo').append("<p class=\"bannerButton\"><a class=\"btn\" href=\"" + a.url + "\">" + a.text + "</a></p>");
        }

        n.addClass('banner--videoActive');
        jQuery('.js-closeBannerVideo').click(() => {
          n.removeClass('banner--videoActive');
          if (jQuery(window).width() >= breakpoint) jQuery('#bannerVideo').remove();else setTimeout(() => {
            jQuery('#bannerVideo').remove();
          }, 750);
        });
      });
    }).fail(() => {
      V.append("<div id=\"bannerVideo\"><div class=\"embedWrapper\"><div class=\"embedContainer\"><iframe src=\"//players.brightcove.net/3415345270001/S1PSLnzml_default/index.html?videoId=ref:" + V.data('videoId') + "_1&secureConnections=true&secureHTMLConnections=true\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div>");
    });
    const J = s + "/api/en_US/review/list?site=1132&type=1&locales=en&nb=3&offer=";
    const productReviewsTemplate = handlebarsSafeCompile(jQuery('#productReviewsTemplate').html());
    let q = 0;
    const Q = jQuery('#productAggregateRating').data('reviews');
    window.starsTemplate = handlebarsSafeCompile(jQuery('#productAggregateRating').html());
    window.reviewsflushlist = false;
    window.reviewsinitialized = false;

    function w(e) {
      if (window.reviewsflushlist) {
        jQuery('.js-reviews .productReview').remove();
        window.reviewsflushlist = false;
      }

      if (e.total_item_count > 0) {
        if (!window.reviewsinitialized) {
          jQuery('.js-reviewsContainer').removeClass('u-displayNone');
          jQuery('.js-productAggregateRating').html(window.starsTemplate(e));
          jQuery('.js-productAggregateRating').on('click', () => {
            jQuery(document).scrollTop(jQuery('#reviews').offset().top - 70);
          });
          window.reviewsinitialized = true;
        }

        jQuery(e.items).each((e, t) => {
          t.country = t.country_label[t.country];
          t.helpfulUrl = t.url_vote.split('/');
          t.helpfulUrl.splice(t.helpfulUrl.length - 1, 0, 'useful');
          t.helpfulUrl = t.helpfulUrl.join('/').replace('utility/view', 'utility/vote');
          t.notHelpfulUrl = t.helpfulUrl.replace('useful', 'useless');
          if (t.answer) t.answer.helpfulUrl = t.helpfulUrl.replace(t.id, t.answer.id);
        });
        jQuery('.js-reviews .productReview').last().addClass('u-marginBottom2x');
        jQuery('.js-reviews > .grid--full').append(productReviewsTemplate({
          reviews: e.items
        }));
        jQuery('.js-reviewFeedback').on('click', e => {
          e.preventDefault();
          jQuery.get(e.currentTarget.href).then(e => {
            console.log(e);
          });
        });
        if (3 * q >= Q.total_item_count) jQuery('.js-loadReviews').hide();else jQuery('.js-loadReviews').show();
      }
    }

    const loadReviews = () => {
      if (window.reviewsflushlist) q = 0;
      const e = (jQuery('.js-productReviewsSort').val() || 'createdAt|desc').split('|');
      const i = 3 * q;
      q++;
      if (!(!Q || i >= Q.total_item_count)) if (e[0] === 'createdAt' && e[1] === 'desc' && q <= 5) w({
        total_item_count: Q.total_item_count,
        items: Q.items.slice(i, i + 3)
      });else jQuery.get(J + modelCode + "&page=" + q + "&sort=" + e[0] + "&direction=" + e[1]).then(w);
    };

    loadReviews();
    jQuery('.js-loadReviews').click(e => {
      e.preventDefault();
      loadReviews();
    });
    jQuery('.js-productReviewsSort').change(() => {
      window.reviewsflushlist = true;
      loadReviews();
    });
  };

  if (modelCode) {
    initWithModelCode();
  }

  const variantId = decode(location.search.substring(1));

  if (variantId) {
    const K = jQuery("option[value=\"" + variantId + "\"]").text();
    jQuery('.selector-wrapper--color .option').each(function () {
      const e = jQuery(this);
      if (K.indexOf(e.data('value')) > -1) e.click();
    });
  }

  jQuery('body').append(jQuery('.sizechart').detach());
  const X = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  let Y = false;
  jQuery('.js-sizechart').click(i => {
    i.preventDefault();
    if (jQuery(window).width() < 768) jQuery('html, body').css({
      overflow: 'hidden',
      position: 'fixed'
    });

    if (!Y) {
      const n = setInterval(() => {
        if (jQuery('.sizeGuide').html() !== '') {
          const e = jQuery('.esc-size-guide--title').text().replace(/\(.*\)/, e => "<br/><span style=\"font-size:60%\">" + e + "</span>");
          jQuery('.sizechart-title').html(e);
          jQuery('.sizechart-measurements').html(jQuery('.esc-size-guide--table + p').html());
          clearInterval(n);
        }
      }, 100);
      Y = true;
      if (X) jQuery('.sizechart .u-centerVertically').removeClass('u-centerVertically');
    }

    jQuery('.sizechart').css('display', 'block');
    jQuery('html').addClass('is-showingSizeChart');
  });
  jQuery('.js-closeSizechart').click(() => {
    if (jQuery(window).width() < 768) jQuery('html, body').css({
      overflow: '',
      position: ''
    });
    jQuery('.sizechart').css('display', 'none');
    jQuery('html').removeClass('is-showingSizeChart');
  });
});
